import React from 'react';
import { CountryListProps } from '@paypalcorp/pp-react';
import styles from './CountrySelector.module.less';
import CountryDropdown from './CountryDropdown';
import classNames from 'classnames';
import { isUserLoggedInSelector } from '../../../store/App/selectors';
import { useSelector } from 'react-redux';
interface CountrySelectorProps {
  ecmContent: {
    jsonObject: {
      options: Array<CountryListProps>;
    };
  };
}

const CountrySelector = ({ ecmContent }: CountrySelectorProps) => {
  const countryList = ecmContent?.jsonObject?.options || [];
  const isUserLoggedIn = useSelector(isUserLoggedInSelector);
  const country_selector_container = classNames(styles.country_selector_container, {
    [styles.country_selector_container_loggedIn]: isUserLoggedIn
  });

  return (
    <div className={country_selector_container}>
      <CountryDropdown countryList={countryList} />
    </div>
  );
};

export default CountrySelector;
